import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const voucherAdd = createReducer(
  {
    loading: false,
    activated: false,
    voucher: ''
  },
  {
    [ActionTypes.ADD_VOUCHER_COUPON_REQUEST]: state => {
      return { ...state, loading: true };
    },
    [ActionTypes.ADD_VOUCHER_COUPON_SUCCESS]: (state, { payload }) => {
      return { ...state, activated: true, voucher: payload };
    },
    [ActionTypes.ADD_VOUCHER_COUPON_DONE]: state => {
      return { ...state, loading: false };
    },
    [ActionTypes.ADD_VOUCHER_COUPON_ERROR]: state => {
      return { ...state, loading: false, activated: false, voucher: '' };
    }
  }
);

export default voucherAdd;
